module.exports = __webpack_public_path__ + "img/ic-media-active.7104d9e1.svg";